import React, { useState, useEffect } from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";
import { CardContainer } from "../UserInterface/CardContainer";
import Pagination from "../Pagination/Pagination";
import UseWindowSize from "../UseWindowSize";

const ContentContainer = ({ data, subSlug }) => {
  const list = data.item;
  const pageNumber = [];
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  const [state, setState] = useState({
    listPage: list,
    currentPage: 1,
    listPerPage: 12
  });

  useEffect(() => {
    setWinSize(width);
  });

  const { listPage, currentPage, listPerPage } = state;
  const indexOfLast = currentPage * listPerPage;
  const indexOfFirst = indexOfLast - listPerPage;
  const currentlistPage = listPage?.slice(indexOfFirst, indexOfLast);
  const renderlistPage = currentlistPage?.map((i, index) => {
    return (
      <CardContainer
        key={index}
        img={i.banner}
        title={i.title}
        date={i.pers_date}
        button="Baca"
        href={`/tentang-perusahaan/${subSlug}/[slug]`}
        slug={`/tentang-perusahaan/${subSlug}/${i.slug}`}
      />
    );
  });

  for (let i = 1; i <= Math.ceil(list?.length / listPerPage); i++) {
    pageNumber.push(i);
  }

  return (
    <React.Fragment>
      <LayoutCenter widthLayout="1000px">
        <div className="pers-list-container">{renderlistPage}</div>
      </LayoutCenter>
      <Pagination pageNumber={pageNumber} currentPage={currentPage} winSize={winSize} state={state} setState={setState} />
      <style jsx>{`
        .pers-list-container {
          width: 100%;
          display: grid;
          grid-column-gap: 20px;
          grid-row-gap: 50px;
          grid-template-columns: 1fr 1fr 1fr;
        }
        @media only screen and (max-width: 600px) {
          .pers-list-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </React.Fragment>

  )
}

export default ContentContainer;